module.exports = __webpack_public_path__ + "img/logo.12a4e04f.png";